// src/StickyNotesPanel.js 

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'; // Aggiunti useCallback, useRef
import './StickyNotesPanel.css';
import { db } from './firebase';
import {
    collection,
    query,
    orderBy,
    onSnapshot,
    addDoc,
    deleteDoc,
    doc,
    updateDoc,
    serverTimestamp
} from 'firebase/firestore';
import { useUser } from './UserContext';

// Funzione helper per il debounce
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

const defaultColors = ["#FFFACD", "#ADD8E6", "#90EE90", "#FFB6C1", "#FFDAB9", "#E6E6FA"];

const StickyNotesPanel = ({ isOpen, onClose }) => {
    const { userProfile } = useUser();
    const [notes, setNotes] = useState([]);
    const [newNoteTitle, setNewNoteTitle] = useState(''); // Stato per il nuovo titolo
    const [newNoteText, setNewNoteText] = useState('');
    const [newNoteColor, setNewNoteColor] = useState(defaultColors[0]);
    const [isLoading, setIsLoading] = useState(true);
    const notesRef = useRef(notes); // Usiamo un ref per accedere allo stato più recente nel debounce
    const [isAddModalOpen, setIsAddModalOpen] = useState(false); // Stato per l'accordion, aperto di default

    const [searchTerm, setSearchTerm] = useState('');
    
    // --- FIX 1: Rimosso lo stato [filteredNotes, setFilteredNotes] ---

    // Aggiorna il ref ogni volta che le note cambiano
    useEffect(() => {
        notesRef.current = notes;
    }, [notes]);


    // Carica le note da Firestore in tempo reale
    useEffect(() => {
    // --- INIZIO MODIFICA: Guard e centerId ---
    if (!userProfile || !userProfile.centerId) {
        setNotes([]);
        setIsLoading(false);
        return;
    }
    const centerId = userProfile.centerId;

    setIsLoading(true);
    // Usa il nuovo percorso nidificato
    const notesCollectionRef = collection(db, 'centers', centerId, 'stickyNotes'); // <-- MODIFICA QUI
    // --- FINE MODIFICA ---

    const q = query(notesCollectionRef, orderBy('createdAt', 'asc'));

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const notesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setNotes(notesData);
            setIsLoading(false);
            console.log("Note caricate/aggiornate da Firestore:", notesData.length); // Log per debug
        }, (error) => {
            console.error("Errore nel leggere le sticky notes:", error);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [userProfile]); // <-- MODIFICA QUI

    // --- FIX 2: Rimosso l'useEffect che aggiornava filteredNotes ---
    // (useEffect rimosso da qui)

    // Funzione per aggiungere una nota a Firestore (con titolo)
    const addNote = async () => {
    if (newNoteText.trim() === '') return;
    if (!userProfile || !userProfile.centerId) return;

    setIsLoading(true);
    try {
        await addDoc(collection(db, 'centers', userProfile.centerId, 'stickyNotes'), {
            title: newNoteTitle.trim(),
            text: newNoteText.trim(),
            color: newNoteColor,
            createdAt: serverTimestamp(),
            centerId: userProfile.centerId
        });
        setNewNoteTitle('');
        setNewNoteText('');
        setNewNoteColor(defaultColors[0]);
        setIsAddModalOpen(false); // Chiudi il modale
        console.log("Nota aggiunta con successo.");
    } catch (error) {
        console.error("Errore nell'aggiungere la nota:", error);
        setIsLoading(false);
    }
};

    
    // Funzione per eliminare una nota da Firestore
const deleteNote = async (idToDelete) => {
    if (!userProfile || !userProfile.centerId) return; // Controllo di sicurezza
    try {
        const noteDocRef = doc(db, 'centers', userProfile.centerId, 'stickyNotes', idToDelete); // <-- MODIFICA QUI
            await deleteDoc(noteDocRef);
             console.log("Nota eliminata:", idToDelete); // Log per debug
        } catch (error) {
            console.error("Errore nell'eliminare la nota:", error);
        }
    };

    // Funzione interna per aggiornare Firestore (usata dal debounce)
    const updateNoteInFirestore = useCallback(async (idToUpdate, field, value) => {
    if (!userProfile || !userProfile.centerId) return;
     // --- FINE MODIFICA ---

     console.log(`Tentativo di aggiornare ${field} per nota ${idToUpdate}`); // Log per debug
    try {
        const noteDocRef = doc(db, 'centers', userProfile.centerId, 'stickyNotes', idToUpdate); // <-- MODIFICA QUI
            await updateDoc(noteDocRef, {
                [field]: value // Aggiorna dinamicamente il campo (title o text)
            });
             console.log(`Nota ${idToUpdate} aggiornata (${field})`); // Log per debug
        } catch (error) {
            console.error(`Errore nell'aggiornare ${field} della nota ${idToUpdate}:`, error);
        }
    }, [userProfile]);

    // Crea versioni debounced delle funzioni di aggiornamento
    // useCallback assicura che la funzione debounced non venga ricreata ad ogni render
    const debouncedUpdateTitle = useMemo(() => 
    debounce(updateNoteInFirestore, 800)
, [updateNoteInFirestore]);

const debouncedUpdateText = useMemo(() => 
    debounce(updateNoteInFirestore, 800)
, [updateNoteInFirestore]);

    // Gestore per la modifica del TITOLO (aggiorna stato locale + chiama debounce)
    const handleTitleChange = (idToUpdate, newTitle) => {
        // Aggiorna lo stato locale immediatamente per reattività
        // Questo è il comando che causa il bug, ma è necessario per il filtro
        setNotes(currentNotes =>
            currentNotes.map(n =>
                n.id === idToUpdate ? { ...n, title: newTitle } : n
            )
        );
        // Chiama la funzione debounced per salvare su Firestore dopo il ritardo
        debouncedUpdateTitle(idToUpdate, 'title', newTitle);
    };

    // Gestore per la modifica del TESTO (aggiorna stato locale + chiama debounce)
   {/* const handleTextChange = (idToUpdate, newText) => {
        // Aggiorna lo stato locale immediatamente
        setNotes(currentNotes =>
            currentNotes.map(n =>
                n.id === idToUpdate ? { ...n, text: newText } : n
            )
        );
        // Chiama la funzione debounced
        debouncedUpdateText(idToUpdate, 'text', newText);
    }; */}

    // Funzione per applicare formattazione al testo selezionato
const applyFormatting = (command) => {
    document.execCommand(command, false, null);
};


    // Impedisce la chiusura se si clicca all'interno del pannello
    const handlePanelClick = (e) => {
        e.stopPropagation();
    };

    // --- Gestione Visibilità ---
    // Aggiungiamo classi CSS per gestire la visibilità e l'animazione
    // invece di restituire null, così l'effetto di transizione funziona correttamente
    const overlayClass = isOpen ? 'sticky-notes-overlay open' : 'sticky-notes-overlay';
    const panelClass = isOpen ? 'sticky-notes-panel open' : 'sticky-notes-panel';

    // --- FIX 3: Calcola filteredNotes direttamente qui, prima del return ---
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const filteredNotes = notes.filter(note => {
        if (lowerCaseSearchTerm === '') {
            return true; // Mostra tutto se la ricerca è vuota
        }
        const titleMatch = note.title ? note.title.toLowerCase().includes(lowerCaseSearchTerm) : false;
        const textMatch = note.text ? note.text.toLowerCase().includes(lowerCaseSearchTerm) : false;
        return titleMatch || textMatch;
    });
    // --- FINE FIX 3 ---

    return (
        <div className={overlayClass} onMouseDown={onClose}>
            <div className={panelClass} onMouseDown={handlePanelClick}>
                <div className="sticky-notes-header">
                    <h3>Note Rapide Condivise</h3>
                    <button onClick={onClose} className="close-notes-btn">✖</button>
                </div>

                <div className="sticky-notes-content">
    {/* Pulsante Aggiungi Sticky Note */}
    <button 
        className="add-sticky-btn" 
        onClick={() => setIsAddModalOpen(true)}
    >
        ➕ Aggiungi Sticky Note
    </button>
    
    {/* Barra di ricerca */}
    <div className="sticky-notes-search-bar">
                    <input
                        type="text"
                        placeholder="Cerca note per titolo o testo..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                    {/* Lista Note */}
                    <div className="notes-list">
                        {isLoading && <p className="loading-message">Caricamento note...</p>}
                        {isLoading && <p className="loading-message">Caricamento note...</p>}
{!isLoading && notes.length === 0 && <p className="no-notes-message">Nessuna nota condivisa presente.</p>}
{/* --- FIX 4: Usa 'filteredNotes' ovunque qui sotto --- */}
{!isLoading && notes.length > 0 && filteredNotes.length === 0 && (
    <p className="no-notes-message">Nessuna nota trovata per "{searchTerm}".</p>
)}
                        {filteredNotes.map(note => (
    <div key={note.id} className="note-item" style={{ backgroundColor: note.color || '#FFFACD' }}>
        <input
            type="text"
            value={note.title || ''}
            onChange={(e) => handleTitleChange(note.id, e.target.value)}
            placeholder="Titolo..."
            className="note-title-input"
        />
        
        {/* CONTENUTO RICH TEXT EDITABILE */}
        <div
    contentEditable
    suppressContentEditableWarning
    ref={(el) => {
        if (el && !el.hasAttribute('data-initialized')) {
            el.innerHTML = note.text || '';
            el.setAttribute('data-initialized', 'true');
        }
    }}
    onInput={(e) => {
        const htmlContent = e.currentTarget.innerHTML;
        debouncedUpdateText(note.id, 'text', htmlContent);
    }}
    placeholder="Contenuto..."
    className="note-text-input note-text-editable"
/>
        
        {/* TOOLBAR FORMATTAZIONE */}
        <div className="note-formatting-toolbar">
            <button
                type="button"
                className="format-btn"
                onClick={() => applyFormatting('bold')}
                title="Grassetto (Ctrl+B)"
            >
                <strong>B</strong>
            </button>
            <button
                type="button"
                className="format-btn"
                onClick={() => applyFormatting('italic')}
                title="Corsivo (Ctrl+I)"
            >
                <em>I</em>
            </button>
            <button
                type="button"
                className="format-btn"
                onClick={() => applyFormatting('underline')}
                title="Sottolineato (Ctrl+U)"
            >
                <u>U</u>
            </button>
            <button onClick={() => deleteNote(note.id)} className="delete-note-btn" style={{ marginLeft: 'auto' }}>
                Elimina
            </button>
        </div>
    </div>
))}
                    </div>
                </div>
            
            {isAddModalOpen && (
                <div className="add-note-modal-overlay" onClick={() => setIsAddModalOpen(false)}>
                    <div className="add-note-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>➕ Nuova Sticky Note</h3>
                            <button className="modal-close-btn" onClick={() => setIsAddModalOpen(false)}>✖</button>
                        </div>
                        
                        <div className="modal-body">
                            <input
                                type="text"
                                value={newNoteTitle}
                                onChange={(e) => setNewNoteTitle(e.target.value)}
                                placeholder="Titolo (opzionale)"
                                className="modal-input-title"
                            />
                            <textarea
                                value={newNoteText}
                                onChange={(e) => setNewNoteText(e.target.value)}
                                placeholder="Scrivi una nuova nota condivisa..."
                                rows="5"
                                className="modal-textarea"
                            />
                            <div className="modal-color-picker">
    <span>Colore:</span>
    <div className="color-picker-large">
        <input
            type="color"
            value={newNoteColor}
            onChange={(e) => setNewNoteColor(e.target.value)}
            className="color-input-large"
        />
        <div 
            className="color-preview" 
            style={{ backgroundColor: newNoteColor }}
            title={newNoteColor}
        >
            {newNoteColor}
        </div>
    </div>
</div>
                        </div>
                        
                        <div className="modal-footer">
                            <button className="modal-cancel-btn" onClick={() => setIsAddModalOpen(false)}>
                                Annulla
                            </button>
                            <button className="modal-add-btn" onClick={addNote}>
                                Aggiungi
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
};

export default StickyNotesPanel;